module.exports = __webpack_public_path__ + "474bcee7556c696549f1701a51b47ae9.pdf";